import { css, styled } from '@mui/material'

export const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'extraPaddingTop',
})<{ extraPaddingTop?: boolean }>`
  padding-bottom: ${({ theme }) => theme.spacing(3)};
  ${({ extraPaddingTop, theme }) =>
    extraPaddingTop &&
    css`
      padding-top: ${theme.spacing(3)};
    `}
`
